import { CircleNotch, X } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { num } from '@/lib/format'
import { MAX_BULK_ACK_POS } from './bulk-ack-eligibility'

export function BulkAckSelectionBar({
  selectedCount,
  matchingTotal,
  selectingMatching,
  writesAllowed,
  onAcknowledge,
  onClear,
  onSelectMatching,
}: {
  selectedCount: number
  matchingTotal: number | null
  selectingMatching: boolean
  writesAllowed: boolean
  onAcknowledge: () => void
  onClear: () => void
  onSelectMatching: () => void
}) {
  if (selectedCount <= 0 && matchingTotal == null) return null

  return (
    <div
      data-testid="bulk-ack-selection-bar"
      className="sticky bottom-3 z-30 mx-auto flex w-full max-w-3xl flex-wrap items-center justify-between gap-2 rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-2 shadow-[var(--shadow-raised)]"
      role="region"
      aria-label="Bulk acknowledgement selection"
    >
      <div className="flex min-w-0 flex-col gap-0.5 text-[12.5px]">
        <span className="font-semibold tabular-nums text-[color:var(--foreground)]">
          {num(selectedCount)} {selectedCount === 1 ? 'PO' : 'POs'} selected
          <span className="font-normal text-[color:var(--muted-foreground)]">
            {' '}
            · max {MAX_BULK_ACK_POS}
          </span>
        </span>
        {matchingTotal != null && matchingTotal > selectedCount ? (
          <button
            type="button"
            className="w-fit text-left text-[11.5px] text-[color:var(--primary)] underline-offset-2 hover:underline disabled:opacity-50"
            disabled={selectingMatching || !writesAllowed || selectedCount >= MAX_BULK_ACK_POS}
            onClick={onSelectMatching}
          >
            {selectingMatching ? (
              <span className="inline-flex items-center gap-1">
                <CircleNotch className="size-3 animate-spin" /> Selecting…
              </span>
            ) : matchingTotal > MAX_BULK_ACK_POS ? (
              `Select first ${MAX_BULK_ACK_POS} of ${num(matchingTotal)} matching filters`
            ) : (
              `Select all ${num(matchingTotal)} matching filters`
            )}
          </button>
        ) : null}
      </div>
      <div className="flex items-center gap-2">
        <Button type="button" variant="outline" size="sm" onClick={onClear}>
          <X className="size-3.5" /> Clear
        </Button>
        <Button
          type="button"
          size="sm"
          disabled={selectedCount === 0 || !writesAllowed}
          onClick={onAcknowledge}
        >
          Acknowledge
        </Button>
      </div>
    </div>
  )
}
